import {
  ArrowUpRight,
  Download,
  Link2,
  MousePointer2,
  Plus,
} from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from '../i18n/Link'
import SEO, { schemas } from '../components/SEO'
import Hero from '../components/Hero'
import FeaturesSection from '../components/FeaturesSection'
const stepIcons = [Download, Link2, MousePointer2]
export default function Home() {
  const { t } = useTranslation('home')
  const steps = (t('steps', { returnObjects: true }) as { title: string; text: string }[]).map(
    (step, i) => ({ ...step, icon: stepIcons[i] }),
  )
  const faqs = t('faq', { returnObjects: true }) as { q: string; a: string }[]
  return (
    <div className="premium-home">
      <SEO
        title={t('seo.title')}
        description={t('seo.description')}
        keywords={t('seo.keywords')}
        canonical="/"
        isHome
        structuredData={[schemas.organization, schemas.website, schemas.softwareApp, schemas.faq(faqs)]}
      />
      <Hero />
      <FeaturesSection />
      <section className="workflow-section">
        <div className="page-width">
          <div className="section-heading">
            <div>
              <div className="eyebrow">{t('workflow.eyebrow')}</div>
              <h2>
                {t('workflow.title1')}
                <br />
                <span>{t('workflow.titleAccent')}</span>
              </h2>
            </div>
            <Link className="text-link" to="/docs">
              {t('workflow.guide')} <ArrowUpRight size={17} />
            </Link>
          </div>
          <div className="workflow-grid">
            {steps.map(({ icon: Icon, title, text }, i) => (
              <article key={title}>
                <div className="step-top">
                  <Icon size={24} />
                  <span>0{i + 1}</span>
                </div>
                <h3>{title}</h3>
                <p>{text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
      <section className="faq-section page-width">
        <div>
          <div className="eyebrow">{t('faqSection.eyebrow')}</div>
          <h2>
            {t('faqSection.title1')}
            <br />
            <span>{t('faqSection.titleAccent')}</span>
          </h2>
          <Link className="text-link" to="/help">
            {t('faqSection.helpCenter')} <ArrowUpRight size={16} />
          </Link>
        </div>
        <div className="faq-list">
          {faqs.map(({ q, a }) => (
            <details key={q}>
              <summary>
                {q}
                <Plus size={18} />
              </summary>
              <p>{a}</p>
            </details>
          ))}
        </div>
      </section>
      <section className="closing-section page-width">
        <div className="closing-panel">
          <div className="closing-orbit" aria-hidden="true" />
          <div>
            <div className="eyebrow">{t('closing.eyebrow')}</div>
            <h2>
              {t('closing.title1')}
              <br />
              <span>{t('closing.titleAccent')}</span>
            </h2>
            <p>{t('closing.text')}</p>
          </div>
          <div className="closing-actions">
            <Link className="cream-button" to="/download">
              {t('closing.start')} <ArrowUpRight size={18} />
            </Link>
            <Link to="/contact">
              {t('closing.talk')} <ArrowUpRight size={15} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  )
}
